import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const InfoIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm1.25-8a1.25 1.25 0 1 0-2.5 0v3.75a1.25 1.25 0 1 0 2.5 0V8Zm0-3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z", fill: "currentColor" })));
});
InfoIcon.displayName = 'InfoIcon';
export default InfoIcon;
